import './divi-styles.css'
import './i18n/i18next'
import { Tasks } from './Tasks'
import { render } from '@wordpress/element'
import { Draggable } from '#components/Draggable'
import dreamhostLogo from '#assets/dreamhost.svg'
import mktgooLogo from '#assets/mktgoo.svg'

const SettingsButton = ({ onClick, children }) => {
  const className = [
    'et-fb-button',
    'et-fb-button--elevate',
    'et-fb-button--primary',
    'et-fb-button--round',
  ].join(' ')
  return (
    <button className={className} onClick={onClick}>
      {children}
    </button>
  )
}

window.addEventListener('message', function (event) {
  if ('et_builder_api_ready' === event.data.eventType) {
    const modalId = document.getElementById('marketgoo-app-modal')
    const settingsButtonId = document.getElementById('marketgoo-settings')

    const buttonGroup = document.querySelector(
      '.et-fb-page-settings-bar__column--main .et-fb-button-group'
    )
    buttonGroup.append(settingsButtonId)

    if (settingsButtonId) {
      render(
        <SettingsButton onClick={() => modalId.classList.toggle('visible')}>
          <img
            src={
              window.marketgoo?.partnerkey === 'dreamhost'
                ? dreamhostLogo
                : mktgooLogo
            }
          />
        </SettingsButton>,
        settingsButtonId
      )
    }

    if (modalId) {
      render(
        <Draggable>
          <Tasks />
        </Draggable>,
        modalId
      )
    }
  }
})
